var products = [{
            Men: [
                {
                    product: "Triathlon",
                    name: "Prana Core Men's Eco Triathlon Wetsuit Limited Edition",
                    price: 1299.95,
                    optionData: {
                        Price: [
                            {//编写价格的默认动态图片数据
                                icon: 'Fish Scale',
                                title: 'Next-gen',
                                content: 'Bio-Skin'
                            }, {
                                icon: 'Even Buoyancy',
                                title: 'Even',
                                content: 'Buoyancy'
                                
                            }, {
                               icon: '#45',
                                title: 'Best',
                                content: 'Shoulder Flexibility'
                               
                            }, {
                                icon: 'NANO SCS',
                                title: 'Fastest',
                                content: 'Hydrodynamic Coating'
                            }
                        ],
                        Performance: {
                            Performance: [
                                {
                                icon: 'Fish Scale',
                                title: 'Next-gen',
                                content: 'Bio-Skin'
                            }, {
                                icon: 'Even Buoyancy',
                                title: 'Even',
                                content: 'Buoyancy'
                                
                            }, {
                               icon: '#45',
                                title: 'Best',
                                content: 'Shoulder Flexibility'
                               
                            }, {
                                icon: 'NANO SCS',
                                title: 'Fastest',
                                content: 'Hydrodynamic Coating'
                                }
                            ], Speed: [

                            ], Buoyancy: [

                            ], ShoulderFlexibility: [

                            ], BodyStretch: [

                            ]
                        }
                    },
                    flexibility: 5,
                    buoyancy: 5,
                    speed: 5,
                    thermal: 5,
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Prana_Core_men_101396be-01f8-4a6a-a6f7-e87367534951.png?v=1741141387",
                    product_url: 'https://eu.sumarpo.com/products/prana-core-mens-eco-triathlon-wetsuit',
                    property: "Performance"
                },
                {
                    product: "Triathlon",
                    name: "Victory Men's Eco Triathlon Wetsuit",
                    price: 799.95,
                    optionData: {
                        Price: [
                            {//编写价格的默认动态图片数据
                                icon: 'Even Buoyancy',
                                title: 'Even',
                                content: 'Buoyancy'
                            }, {
                                icon: '#45',
                                title: 'Best',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'NANO SCS',
                                title: 'Fastest',
                                content: 'Hydrodynamic Coating'
                            }
                        ],
                        Performance: {
                            Performance: [
                                {
                                    icon: 'Even Buoyancy',
                                title: 'Even',
                                content: 'Buoyancy'
                            }, {
                                icon: '#45',
                                title: 'Best',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'NANO SCS',
                                title: 'Fastest',
                                content: 'Hydrodynamic Coating'
                                }
                            ], Speed: [

                            ], Buoyancy: [

                            ], ShoulderFlexibility: [
                                {
                                    icon: 'Buoyancy',
                                    title: 'More',
                                    content: 'Buoyancy'
                                }, {
                                    icon: 'Even Buoyancy',
                                    title: 'Even',
                                    content: 'Buoyancy'
                                }, {
                                    icon: '#45',
                                    title: 'Best',
                                    content: 'Shoulder Flexibility'
                                }, {
                                    icon: 'NANO SCS',
                                    title: 'Fastest',
                                    content: 'Hydrodynamic Coating'
                                }
                            ], BodyStretch: [

                            ]
                        }
                    },
                    flexibility: 5, buoyancy: 4.5,
                    speed: 5, thermal: 5,
                    image_url: "https://eu.sumarpo.com/cdn/shop/files/5-12-10363089_1280x1800_f22945f8-b31b-49c2-9c6b-e087260dbb33_1800x1800.jpg?v=1779343646",
                    product_url: 'https://eu.sumarpo.com/products/victory-mens-eco-triathlon-wetsuit-preorder',
                    property: "Performance,ShoulderFlexibility"
                },
                {
                    product: "Triathlon",
                    name: "Elite Pro Men's Eco Triathlon Wetsuit",
                    price: 679.95,
                    optionData: {
                        Price: [
                            {//编写价格的默认动态图片数据
                                icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: '#40',
                                title: 'Great',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'NANO SCS',
                                title: 'Fastest',
                                content: 'Hydrodynamic Coating'
                            }, 
                        ],
                        Performance: {
                            Performance: [
                                {
                                    icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: '#40',
                                title: 'Great',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'NANO SCS',
                                title: 'Fastest',
                                content: 'Hydrodynamic Coating'
                                }
                            ], Speed: [

                            ], Buoyancy: [
                                {
                                    icon: 'Buoyancy',
                                    title: 'More',
                                    content: 'Buoyancy'
                                }, {
                                    icon: 'Leg Buoyancy',
                                    title: 'Leg',
                                    content: 'Buoyancy'
                                }, {
                                    icon: '#40',
                                    title: 'Better',
                                    content: 'Shoulder Flexibility'
                                }, {
                                    icon: 'NANO SCS',
                                    title: 'Fastest',
                                    content: 'Hydrodynamic Coating'
                                }
                            ], ShoulderFlexibility: [

                            ], BodyStretch: [

                            ]
                        }
                    },
                    flexibility: 4.5, buoyancy: 5,
                    speed: 4.5, thermal: 5,
                    image_url: "https://eu.sumarpo.com/cdn/shop/files/27_e46895e6-ef68-452a-998d-7a6f747ca1a5_1800x1800.jpg?v=1754531995",
                    product_url: 'https://eu.sumarpo.com/products/elite-pro-mens-eco-triathlon-wetsuit',
                    property: "Performance,Buoyancy"
                }, {
                    product: "Triathlon",
                    name: "Vanguard Men's Eco Triathlon Wetsuit",
                    price: 579.95,
                     optionData: {
                        Price: [
                            {//编写价格的默认动态图片数据
                                icon: 'Torso Buoyancy',
                                title: 'Torso',
                                content: 'Buoyancy'
                            }, {
                                icon: '#40',
                                title: 'Great',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Faster',
                                content: 'Hydrodynamic Coating'
                            }, 
                        ],
                        Performance: {
                            Performance: [
                    
                            ], Speed: [
                               {
                                icon: 'Torso Buoyancy',
                                title: 'Torso',
                                content: 'Buoyancy'
                            }, {
                                icon: '#40',
                                title: 'Great',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Faster',
                                content: 'Hydrodynamic Coating'
                                }

                            ], Buoyancy: [
                               
                            ], ShoulderFlexibility: [

                            ], BodyStretch: [

                            ]
                        }
                    },
                    flexibility: 4.5, buoyancy: 4.5,
                    speed: 4, thermal: 5,
                    product_url: 'https://eu.sumarpo.com/products/vanguard-mens-eco-triathlon-wetsuit',
                    image_url: "https://eu.sumarpo.com/cdn/shop/files/Vanguardmenswetsuit_1800x1800.jpg?v=1764311604",
                    property: "Speed"
                },
                {
                    product: "Triathlon",
                    name: "Vanguard Men's Eco Sleeveless Triathlon Wetsuit",
                    price: 449.95,
                    optionData: {
                        Price: [
                           
                        ],
                        Performance: {
                            Performance: [
                    
                            ], Speed: [

                            ], Buoyancy: [
                               
                            ], ShoulderFlexibility: [
                               {
                                icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: 'Sleeveless',
                                title: 'Best',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Faster',
                                content: 'Hydrodynamic Coating'
                                }

                            ], BodyStretch: [

                            ]
                        }
                    },
                    flexibility: 5, buoyancy: 4,
                    speed: 4, thermal: 3.5,
                    image_url: "https://eu.sumarpo.com/cdn/shop/files/VanguardSleevelessMain_1800x1800.jpg?v=1779248218",
                    product_url: 'https://eu.sumarpo.com/products/mens-vanguard-sleeveless-eoc-wetsuit',
                    property: "ShoulderFlexibility"
                },
                {
                    product: "Triathlon",
                    name: "Race Men's Eco Triathlon Wetsuit",
                    price: 469.95,
                    optionData: {
                        Price: [
                            {//编写价格的默认动态图片数据
                                icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: '#39',
                                title: 'Good',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Faster',
                                content: 'Hydrodynamic Coating'
                            }, 
                        ],
                        Performance: {
                            Performance: [
                    
                            ], Speed: [
                               {
                                icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: '#39',
                                title: 'Good',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Faster',
                                content: 'Hydrodynamic Coating'
                                }

                            ], Buoyancy: [
                              {
                                icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: '#39',
                                title: 'Good',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Faster',
                                content: 'Hydrodynamic Coating'
                                }
                               
                            ], ShoulderFlexibility: [

                            ], BodyStretch: [

                            ]
                        }
                    },
                    flexibility: 4, buoyancy: 4,
                    speed: 4.5, thermal: 4.5,
                    image_url: "https://eu.sumarpo.com/cdn/shop/files/18_a7022a48-8bc9-4347-b899-acd8d09f7310_1800x1800.jpg?v=1754532213",
                    product_url: 'https://eu.sumarpo.com/products/mens-race-eco-triathlon-wetsuit',
                    property: "Buoyancy,Speed"
                },
                {
                    product: "Triathlon",
                    name: "Nova Men's Eco Triathlon Wetsuit",
                    price: 359.95,
                   optionData: {
                        Price: [
                            {//编写价格的默认动态图片数据
                                icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: '#39',
                                title: 'Good',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Partial Faster',
                                content: 'Hydrodynamic Coating'
                            }, 
                        ],
                        Performance: {
                            Performance: [
                    
                            ], Speed: [
                              
                            ], Buoyancy: [
                              {
                                icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: '#39',
                                title: 'Good',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Partial Faster',
                                content: 'Hydrodynamic Coating'
                                }
                               
                            ], ShoulderFlexibility: [

                            ], BodyStretch: [
                              {
                                icon: 'Buoyancy',
                                title: 'More',
                                content: 'Buoyancy'
                            },{
                                icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: '#39',
                                title: 'Good',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Partial Faster',
                                content: 'Hydrodynamic Coating'
                                }

                            ]
                        }
                    },
                    flexibility: 4, buoyancy: 4,
                    speed: 4, thermal: 4.5,
                    image_url: "https://eu.sumarpo.com/cdn/shop/files/29_70e8bc73-2319-45e9-b969-ba8a25f178bf_1800x1800.jpg?v=1754532397",
                    product_url: 'https://eu.sumarpo.com/products/nova-mens-eco-triathlon-wetsuit',
                    property: "Buoyancy,BodyStretch"
                },
                {
                    product: "Triathlon",
                    name: "Nova Men's Eco Sleeveless Triathlon Wetsuit",
                    price: 299.95,
                      optionData: {
                        Price: [
                           
                        ],
                        Performance: {
                            Performance: [
                    
                            ], Speed: [

                            ], Buoyancy: [
                               
                            ], ShoulderFlexibility: [
                               {
                                icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: 'Sleeveless',
                                title: 'Best',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Partial Faster',
                                content: 'Hydrodynamic Coating'
                                }

                            ], BodyStretch: [

                            ]
                        }
                    },
                    flexibility: 5, buoyancy: 3.5,
                    speed: 3.5, thermal: 3,
                    image_url: "https://eu.sumarpo.com/cdn/shop/files/5-12-10363397_1280x1800_860049ec-b2b0-4c09-bb36-75eb43ca150a_1800x1800.jpg?v=1779343847",
                    product_url: 'https://eu.sumarpo.com/products/mens-nova-sleeveless-eco-wetsuit',
                    property: "ShoulderFlexibility"
                },
                {
                    product: "Triathlon",
                    name: "N-Joy Men's Eco Triathlon Wetsuit",
                    price: 254.95,
                    optionData: {
                        Price: [
                            {//编写价格的默认动态图片数据
                                icon: 'Even Buoyancy',
                                title: 'Even',
                                content: 'Buoyancy'
                            }, {
                                icon: '#39',
                                title: 'Good',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Partial Faster',
                                content: 'Hydrodynamic Coating'
                            }, 
                        ],
                        Performance: {
                            Performance: [
                    
                            ], Speed: [
                             
                            ], Buoyancy: [
                               
                            ], ShoulderFlexibility: [

                            ], BodyStretch: [
                                {
                                icon: 'Even Buoyancy',
                                title: 'Even',
                                content: 'Buoyancy'
                            }, {
                                icon: '#39',
                                title: 'Good',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Partial Faster',
                                content: 'Hydrodynamic Coating'
                                }

                            ]
                        }
                    },
                    flexibility: 4, buoyancy: 3.5,
                    speed: 4, thermal: 4,
                    image_url: "https://eu.sumarpo.com/cdn/shop/files/5-12-10363252_1280x1800_0bae71a3-abbe-4331-91f6-09df7beca350_1800x1800.jpg?v=1779343763",
                    product_url: 'https://eu.sumarpo.com/products/mens-n-joy-eco-wetsuit',
                    property: "BodyStretch"
                },
                {
                    product: "Swimrun",
                    name: "Current Men's Eco Swimrun Wetsuit",
                    price: 599.99,
                    flexibility: 5, buoyancy: 5,
                    speed: 5, thermal: 5,
                    describe: "The ultimate Swimrun Wetsuit for cold weather",
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Current_Man_7a130b82-6013-407c-a660-f2f89cfe0ab0.png?v=1741141387",
                    product_url: "https://eu.sumarpo.com/products/mens-current-eco-swimrun",
                    ProductOptions: "Cooler(Long Sleeves)"
                },
                {
                    product: "Swimrun",
                    name: "X-Ray Men's Eco Swimrun Wetsuit",
                    price: 539.99,
                    flexibility: 4.5, buoyancy: 5,
                    speed: 4.5, thermal: 5,
                    describe: "Great all-around Swimrun Wetsuit with style",
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/X-ray_Man_60b1bd5a-5c87-4e81-99e1-d411e2015181.png?v=1741141387",
                    product_url: "https://eu.sumarpo.com/products/mens-x-ray-eco-swimrun",
                    ProductOptions: "Cooler(Long Sleeves)"
                },
                {
                    product: "Swimrun",
                    name: "Innovator Men's Eco Swimrun Wetsuit",
                    price: 467.99,
                    flexibility: 4.5, buoyancy: 4.5,
                    speed: 4, thermal: 4.5,
                    describe: "Very comfortable during both swim and run",
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Innovator_Man_7943925a-bb21-445e-921e-386cc9e3c95d.png?v=1741141386",
                    product_url: "https://eu.sumarpo.com/products/mens-innovator-eco-swimrun",
                    ProductOptions: "Cooler(Long Sleeves)"
                },
                {
                    product: "Swimrun",
                    name: "Hyper Pro Men's Eco Swimrun Wetsuit",
                    price: 495.99,
                    flexibility: 5, buoyancy: 4.5,
                    speed: 5, thermal: 4,
                    describe: "The most advanced Swimrun wetsuit in our line up",
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Hyper_Pro_Man_98ce5bfb-008b-424b-ab3b-8d6ff9e614b5.png?v=1741141385",
                    product_url: "https://eu.sumarpo.com/products/mens-hyper-pro-eco-swimrun",
                    ProductOptions: "Warmer(Short Sleeves)"
                },
                {
                    product: "Swimrun",
                    name: "Hyper Fast Men's Eco Swimrun Wetsuit",
                    price: 334.99,
                    flexibility: 5, buoyancy: 4,
                    speed: 4, thermal: 3,
                    describe: "The ultimate hot weather Swimrun Wetsuit. Best for elite swimmers",
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Hyper_Fast_Man_82367580-e92e-4a75-9a18-6bb08cf96fe2.png?v=1741141386",
                    product_url: "https://eu.sumarpo.com/products/mens-hyper-fast-eco-swimrun",
                    ProductOptions: "Warmer(Short Sleeves)"
                },
                {
                    product: "Swimrun",
                    name: "Hyper Light Men's Eco Swimrun Wetsuit",
                    price: 299.99,
                    flexibility: 4.5, buoyancy: 4.5,
                    speed: 4, thermal: 3.5,
                    describe: "A good all-arounder for beginners",
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Hyper_Light_Man_b30fe893-1383-442b-974f-c7f94cceb9b5.png?v=1741141385",
                    product_url: "https://eu.sumarpo.com/products/mens-hyper-light-eco-swimrun",
                    ProductOptions: "Warmer(Short Sleeves)"
                },
                {
                    product: "OpenWaterSwimming",
                    name: "Men's Thermal Titanium Eco Open Water Wetsuit - Preorder",
                    price: 529.95,
                    flexibility: 4, buoyancy: 4.5,
                    speed: 4.5, thermal: 5,
                    describe: "When temperatures drop, the Thermal keeps your body warm and your performance at full speed",
                    image_url: "https://eu.sumarpo.com/cdn/shop/files/mens_thermal_wetsuit_1800x1800.jpg?v=1766131317",
                    product_url: "https://eu.sumarpo.com/products/mens-thermal-titanium-eco-open-water-wetsuit-preorder",
                    ProductOptions: "Higher"
                },
                {
                    product: "OpenWaterSwimming",
                    name: "Aspire-Pro Men's Open Water Swimming Wetsuit",
                    price: 449.95,
                    flexibility: 4, buoyancy: 4,
                    speed: 4.5, thermal: 4.5,
                    describe: "Help intermediate swimmers to gain a lot of speed",
                    image_url: "https://eu.sumarpo.com/cdn/shop/files/5_d8e577c3-7792-4f4f-a87c-3ad70d58bc62_1800x1800.jpg?v=1754531844",
                    product_url: "https://eu.sumarpo.com/products/aspire-pro-mens-open-water-swimming-wetsuit",
                    ProductOptions: "Higher"
                },
                {
                    product: "OpenWaterSwimming",
                    name: "Aspire Men's Open Water Swimming Wetsuit",
                    price: 249.95,
                    flexibility: 4, buoyancy: 3.5,
                    speed: 3.5, thermal: 4,
                    describe: "Great for beginners to test out open water",
                    image_url: "https://eu.sumarpo.com/cdn/shop/files/8_9344eb16-0d13-4e0e-8043-cd002fb72e2c_1800x1800.jpg?v=1754531766",
                    product_url: "https://eu.sumarpo.com/products/aspire-mens-open-water-swimming-wetsuit",
                    ProductOptions: "Lower"
                },
                {
                    product: "OpenWaterSwimming",
                    name: "Nova Men's Eco Sleeveless Open Water Swimming Wetsuit",
                    price: 299.95,
                    flexibility: 5, buoyancy: 3.5,
                    speed: 3.5, thermal: 3,
                    describe: "For more comfortable swims in the summer",
                    image_url: "https://eu.sumarpo.com/cdn/shop/files/5-12-10363397_1280x1800_860049ec-b2b0-4c09-bb36-75eb43ca150a_1800x1800.jpg?v=1779343847",
                    product_url: "https://eu.sumarpo.com/products/mens-nova-sleeveless-eco-open-water-swimming-wetsuit-presale",
                    ProductOptions: "Higher"
                },
                {
                    product: "OpenWaterSwimming",
                    name: "N-Joy Men's Eco Open Water Swimming Wetsuit",
                    price: 254.95,
                    flexibility: 4, buoyancy: 3.5,
                    speed: 4, thermal: 4,
                    describe: "Easily fit every body type",
                    image_url: "https://eu.sumarpo.com/cdn/shop/files/5-12-10363252_1280x1800_0bae71a3-abbe-4331-91f6-09df7beca350_1800x1800.jpg?v=1779343763",
                    product_url: "https://eu.sumarpo.com/products/mens-n-joy-eco-open-water-swimming-wetsuit",
                    ProductOptions: "Lower"
                }
            ],
            Women: [
                {
                    product: "Triathlon",
                    name: "Prana Core Women's Eco Triathlon Wetsuit",
                    price: 1299.95,
                    optionData: {
                        Price: [
                            {//编写价格的默认动态图片数据
                                icon: 'Fish Scale',
                                title: 'Next-gen',
                                content: 'Bio-Skin'
                            }, {
                                icon: 'Even Buoyancy',
                                title: 'Even',
                                content: 'Buoyancy'
                                
                            }, {
                               icon: '#45',
                                title: 'Best',
                                content: 'Shoulder Flexibility'
                               
                            }, {
                                icon: 'NANO SCS',
                                title: 'Fastest',
                                content: 'Hydrodynamic Coating'
                            }
                        ],
                        Performance: {
                            Performance: [
                                {
                                icon: 'Fish Scale',
                                title: 'Next-gen',
                                content: 'Bio-Skin'
                            }, {
                                icon: 'Even Buoyancy',
                                title: 'Even',
                                content: 'Buoyancy'
                                
                            }, {
                               icon: '#45',
                                title: 'Best',
                                content: 'Shoulder Flexibility'
                               
                            }, {
                                icon: 'NANO SCS',
                                title: 'Fastest',
                                content: 'Hydrodynamic Coating'
                                }
                            ], Speed: [

                            ], Buoyancy: [

                            ], ShoulderFlexibility: [

                            ], BodyStretch: [

                            ]
                        }
                    },
                    flexibility: 5, buoyancy: 4.5,
                    speed: 5, thermal: 5,
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Prana_Core_Women_f58b58cb-4ffc-4707-859c-f841f7829e5d.png?v=1741141388",
                    product_url: 'https://eu.sumarpo.com/products/prana-core-womens-eco-triathlon-wetsuit',
                    property: "Performance"
                },
                {
                    product: "Triathlon",
                    name: "Victory Women's Eco Triathlon Wetsuit",
                    price: 799.95,
                    optionData: {
                        Price: [
                            {//编写价格的默认动态图片数据
                                icon: 'Even Buoyancy',
                                title: 'Even',
                                content: 'Buoyancy'
                            }, {
                                icon: '#45',
                                title: 'Best',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'NANO SCS',
                                title: 'Fastest',
                                content: 'Hydrodynamic Coating'
                            }
                        ],
                        Performance: {
                            Performance: [
                                {
                                    icon: 'Even Buoyancy',
                                title: 'Even',
                                content: 'Buoyancy'
                            }, {
                                icon: '#45',
                                title: 'Best',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'NANO SCS',
                                title: 'Fastest',
                                content: 'Hydrodynamic Coating'
                                }
                            ], Speed: [

                            ], Buoyancy: [

                            ], ShoulderFlexibility: [
                                {
                                    icon: 'Buoyancy',
                                    title: 'More',
                                    content: 'Buoyancy'
                                }, {
                                    icon: 'Even Buoyancy',
                                    title: 'Even',
                                    content: 'Buoyancy'
                                }, {
                                    icon: '#45',
                                    title: 'Best',
                                    content: 'Shoulder Flexibility'
                                }, {
                                    icon: 'NANO SCS',
                                    title: 'Fastest',
                                    content: 'Hydrodynamic Coating'
                                }
                            ], BodyStretch: [

                            ]
                        }
                    },
                    flexibility: 5, buoyancy: 4.5,
                    speed: 5, thermal: 5,
                    image_url: "https://eu.sumarpo.com/cdn/shop/files/5-14-10363968_1280x1800_e719de28-c957-462e-8594-a0216d01f107_1800x1800.jpg?v=1779343631",
                    product_url: 'https://eu.sumarpo.com/products/victory-womens-eco-triathlon-wetsuit-preorder',
                    property: "Performance,ShoulderFlexibility"
                },
                {
                    product: "Triathlon",
                    name: "Elite Pro Women's Eco Triathlon Wetsuit",
                    price: 679.95,
                    optionData: {
                        Price: [
                            {//编写价格的默认动态图片数据
                                icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: '#40',
                                title: 'Great',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'NANO SCS',
                                title: 'Fastest',
                                content: 'Hydrodynamic Coating'
                            }, 
                        ],
                        Performance: {
                            Performance: [
                                {
                                    icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: '#40',
                                title: 'Great',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'NANO SCS',
                                title: 'Fastest',
                                content: 'Hydrodynamic Coating'
                                }
                            ], Speed: [

                            ], Buoyancy: [
                                {
                                    icon: 'Buoyancy',
                                    title: 'More',
                                    content: 'Buoyancy'
                                }, {
                                    icon: 'Leg Buoyancy',
                                    title: 'Leg',
                                    content: 'Buoyancy'
                                }, {
                                    icon: '#40',
                                    title: 'Better',
                                    content: 'Shoulder Flexibility'
                                }, {
                                    icon: 'NANO SCS',
                                    title: 'Fastest',
                                    content: 'Hydrodynamic Coating'
                                }
                            ], ShoulderFlexibility: [

                            ], BodyStretch: [

                            ]
                        }
                    },
                    flexibility: 4.5, buoyancy: 5,
                    speed: 4.5, thermal: 5,
                    image_url: "https://eu.sumarpo.com/cdn/shop/files/7_f8dd986c-da2e-47fb-b785-7b1fad7027c6_1800x1800.jpg?v=1754556120",
                    product_url: 'https://eu.sumarpo.com/products/elite-pro-womens-eco-triathlon-wetsuit',
                    property: "Performance,Buoyancy"
                },
                {
                    product: "Triathlon",
                    name: "Vanguard Women's Eco Triathlon Wetsuit",
                    price: 579.95,
                    optionData: {
                        Price: [
                            {//编写价格的默认动态图片数据
                                icon: 'Torso Buoyancy',
                                title: 'Torso',
                                content: 'Buoyancy'
                            }, {
                                icon: '#40',
                                title: 'Great',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Faster',
                                content: 'Hydrodynamic Coating'
                            }, 
                        ],
                        Performance: {
                            Performance: [
                    
                            ], Speed: [
                               {
                                icon: 'Torso Buoyancy',
                                title: 'Torso',
                                content: 'Buoyancy'
                            }, {
                                icon: '#40',
                                title: 'Great',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Faster',
                                content: 'Hydrodynamic Coating'
                                }

                            ], Buoyancy: [
                               
                            ], ShoulderFlexibility: [

                            ], BodyStretch: [

                            ]
                        }
                    },
                    flexibility: 4.5, buoyancy: 4.5,
                    speed: 4.5, thermal: 5,
                    image_url: "https://eu.sumarpo.com/cdn/shop/files/vanguard_wetsuit_1800x1800.jpg?v=1766130920",
                    product_url: 'https://eu.sumarpo.com/products/vanguard-womens-eco-triathlon-wetsuit-preorder',
                    property: "Speed"
                },
                {
                    product: "Triathlon",
                    name: "Vanguard Women's Eco Sleeveless Triathlon Wetsuit",
                    price: 449.95,
                    optionData: {
                        Price: [
                           
                        ],
                        Performance: {
                            Performance: [
                    
                            ], Speed: [

                            ], Buoyancy: [
                               
                            ], ShoulderFlexibility: [
                               {
                                icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: 'Sleeveless',
                                title: 'Best',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Faster',
                                content: 'Hydrodynamic Coating'
                                }

                            ], BodyStretch: [

                            ]
                        }
                    },
                    flexibility: 5, buoyancy: 4,
                    speed: 4, thermal: 3.5,
                    image_url: "https://eu.sumarpo.com/cdn/shop/files/5-14-10364215_1280x1800_67adf74a-f449-4c86-a8a7-621ed57fea19_1800x1800.jpg?v=1779344044",
                    product_url: 'https://eu.sumarpo.com/products/womens-vanguard-sleeveless-eco-wetsuit',
                    property: "ShoulderFlexibility"
                },
                {
                    product: "Triathlon",
                    name: "Race Women's Eco Triathlon Wetsuit",
                    price: 469.95,
                    optionData: {
                        Price: [
                            {//编写价格的默认动态图片数据
                                icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: '#39',
                                title: 'Good',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Faster',
                                content: 'Hydrodynamic Coating'
                            }, 
                        ],
                        Performance: {
                            Performance: [
                    
                            ], Speed: [
                               {
                                icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: '#39',
                                title: 'Good',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Faster',
                                content: 'Hydrodynamic Coating'
                                }

                            ], Buoyancy: [
                              {
                                icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: '#39',
                                title: 'Good',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Faster',
                                content: 'Hydrodynamic Coating'
                                }
                               
                            ], ShoulderFlexibility: [

                            ], BodyStretch: [

                            ]
                        }
                    },
                    flexibility: 4, buoyancy: 4,
                    speed: 4.5, thermal: 4.5,
                    image_url: "https://eu.sumarpo.com/cdn/shop/files/1_62495327-8f5a-4441-9368-0aed5045b46c_1800x1800.jpg?v=1754556424",
                    product_url: 'https://eu.sumarpo.com/products/womens-race-eco-triathlon-wetsuit',
                    property: "Speed"
                },
                {
                    product: "Triathlon",
                    name: "Nova Women's Eco Triathlon Wetsuit",
                    price: 359.95,
                    optionData: {
                        Price: [
                            {//编写价格的默认动态图片数据
                                icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: '#39',
                                title: 'Good',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Partial Faster',
                                content: 'Hydrodynamic Coating'
                            }, 
                        ],
                        Performance: {
                            Performance: [
                    
                            ], Speed: [
                              
                            ], Buoyancy: [
                              {
                                icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: '#39',
                                title: 'Good',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Partial Faster',
                                content: 'Hydrodynamic Coating'
                                }
                               
                            ], ShoulderFlexibility: [

                            ], BodyStretch: [
                              {
                                icon: 'Buoyancy',
                                title: 'More',
                                content: 'Buoyancy'
                            },{
                                icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: '#39',
                                title: 'Good',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Partial Faster',
                                content: 'Hydrodynamic Coating'
                                }

                            ]
                        }
                    },
                    flexibility: 4, buoyancy: 4,
                    speed: 4, thermal: 4.5,
                    image_url: "https://eu.sumarpo.com/cdn/shop/files/6_048980d0-7a27-4d5e-91d7-975fd00146c8_1800x1800.jpg?v=1766126799",
                    product_url: 'https://eu.sumarpo.com/products/nova-womens-eco-triathlon-wetsuit',
                    property: "Buoyancy,BodyStretch"
                },
                {
                    product: "Triathlon",
                    name: "Nova Women's Eco Sleeveless Triathlon Wetsuit",
                    price: 299.95,
                    optionData: {
                        Price: [
                           
                        ],
                        Performance: {
                            Performance: [
                    
                            ], Speed: [

                            ], Buoyancy: [
                               
                            ], ShoulderFlexibility: [
                               {
                                icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: 'Sleeveless',
                                title: 'Best',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Partial Faster',
                                content: 'Hydrodynamic Coating'
                                }

                            ], BodyStretch: [

                            ]
                        }
                    },
                    flexibility: 5, buoyancy: 3.5,
                    speed: 3.5, thermal: 3,
                    image_url: "https://eu.sumarpo.com/cdn/shop/files/26_cb84097a-0e88-4944-a8bc-5e660c84b70b_1800x1800.jpg?v=1766125870",
                    product_url: 'https://eu.sumarpo.com/products/womens-nova-sleeveless-eco-wetsuit',
                    property: "ShoulderFlexibility"
                },
                {
                    product: "Triathlon",
                    name: "N-Joy Women's Eco Triathlon Wetsuit",
                    price: 254.95,
                    optionData: {
                        Price: [
                            {//编写价格的默认动态图片数据
                                icon: 'Even Buoyancy',
                                title: 'Even',
                                content: 'Buoyancy'
                            }, {
                                icon: '#39',
                                title: 'Good',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Partial Faster',
                                content: 'Hydrodynamic Coating'
                            }, 
                        ],
                        Performance: {
                            Performance: [
                    
                            ], Speed: [
                             
                            ], Buoyancy: [
                               
                            ], ShoulderFlexibility: [

                            ], BodyStretch: [
                                {
                                icon: 'Even Buoyancy',
                                title: 'Even',
                                content: 'Buoyancy'
                            }, {
                                icon: '#39',
                                title: 'Good',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Partial Faster',
                                content: 'Hydrodynamic Coating'
                                }

                            ]
                        }
                    },
                    flexibility: 4, buoyancy: 3.5,
                    speed: 4, thermal: 4,
                    image_url: "https://eu.sumarpo.com/cdn/shop/files/5-14-10364089_1280x1800_f106b00c-db78-4cb5-a74a-51c4698b70a7_1800x1800.jpg?v=1779343755",
                    product_url: 'https://eu.sumarpo.com/products/womens-n-joy-eco-wetsuit',
                    property: "BodyStretch"
                },
                {
                    product: "Swimrun",
                    name: "Current Women's Eco Swimrun Wetsuit",
                    price: 599.99,
                    flexibility: 5, buoyancy: 5,
                    speed: 5, thermal: 5,
                    describe: "The ultimate Swimrun Wetsuit for cold weather",
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Current_Woman_c8c6c597-acbf-494c-b1c3-3ad6a65b8ece.png?v=1741141387",
                    product_url: "https://eu.sumarpo.com/products/womens-current-eco-swimrun",
                    ProductOptions: "Cooler(Long Sleeves)"
                },
                {
                    product: "Swimrun",
                    name: "X-Ray Women's Eco Swimrun Wetsuit",
                    price: 539.99,
                    flexibility: 4.5, buoyancy: 5,
                    speed: 4.5, thermal: 5,
                    describe: "Great all-around Swimrun Wetsuit with style",
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/X-Ray_Woman_9479a04c-3017-47e8-8fc5-ddc6035c11f1.png?v=1741141386",
                    product_url: "https://eu.sumarpo.com/products/womens-x-ray-eco-swimrun",
                    ProductOptions: "Cooler(Long Sleeves)"
                },
                {
                    product: "Swimrun",
                    name: "Innovator Women's Eco Swimrun Wetsuit",
                    price: 467.99,
                    flexibility: 4.5, buoyancy: 4.5,
                    speed: 4, thermal: 4.5,
                    describe: "Very comfortable during both swim and run",
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Innovator_Woman_c45aea8e-7f36-499e-8c95-a65c52eafe10.png?v=1741141387",
                    product_url: "https://eu.sumarpo.com/products/womens-innovator-eco-swimrun",
                    ProductOptions: "Cooler(Long Sleeves)"
                },
                {
                    product: "Swimrun",
                    name: "Hyper Pro Women's Eco Swimrun Wetsuit",
                    price: 495.99,
                    flexibility: 5, buoyancy: 4.5,
                    speed: 5, thermal: 4,
                    describe: "The most advanced Swimrun wetsuit in our line up",
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Hyper_Pro_Woman_d11146ca-6276-4a36-9dd3-5d7100246a37.png?v=1741141386",
                    product_url: "https://eu.sumarpo.com/products/womens-hyper-pro-eco-swimrun",
                    ProductOptions: "Warmer(Short Sleeves)"
                },
                {
                    product: "Swimrun",
                    name: "Hyper Fast Women's Eco Swimrun Wetsuit",
                    price: 334.99,
                    flexibility: 5, buoyancy: 4,
                    speed: 4, thermal: 3,
                    describe: "The ultimate hot weather Swimrun Wetsuit. Best for elite swimmers.",
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Hyper_Fast_Woman_cdb89b1e-e137-4891-8d6a-396070c7519b.png?v=1741141386",
                    product_url: "https://eu.sumarpo.com/products/womens-hyper-fast-swimrun",
                    ProductOptions: "Warmer(Short Sleeves)"
                },
                {
                    product: "Swimrun",
                    name: "Hyper Light Women's Eco Swimrun Wetsuit",
                    price: 299.99,
                    flexibility: 4.5, buoyancy: 4.5,
                    speed: 4, thermal: 3.5,
                    describe: "A good all-arounder for beginners",
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Hyper_Light_Woman_dc755c4e-a08f-4e82-90c7-925bbfd4fcfc.png?v=1741141385",
                    product_url: "https://eu.sumarpo.com/products/womens-hyper-light-eco-swimrun",
                    ProductOptions: "Warmer(Short Sleeves)"
                },
                {
                    product: "OpenWaterSwimming",
                    name: "Women's Thermal Titanium Eco Open Water Wetsuit - Preorder",
                    price: 529.95,
                    flexibility: 4, buoyancy: 4,
                    speed: 4.5, thermal: 4.5,
                    describe: "When temperatures drop, the Thermal keeps your body warm and your performance at full speed",
                    image_url: "https://eu.sumarpo.com/cdn/shop/files/thermal_wetsuit_1800x1800.jpg?v=1766131208",
                    product_url: "https://eu.sumarpo.com/products/womens-thermal-titanium-eco-open-water-wetsuit-preorder",
                    ProductOptions: "Higher"
                },
                {
                    product: "OpenWaterSwimming",
                    name: "Aspire-Pro Women's Open Water Swimming Wetsuit",
                    price: 449.95,
                    flexibility: 4, buoyancy: 4,
                    speed: 4.5, thermal: 4.5,
                    describe: "Help intermediate swimmers to gain a lot of speed",
                    image_url: "https://eu.sumarpo.com/cdn/shop/files/19_a01977fc-aea5-4821-8140-75f37daab2b1_1800x1800.jpg?v=1754555827",
                    product_url: "https://eu.sumarpo.com/products/aspire-pro-womens-open-water-swimming-wetsuit",
                    ProductOptions: "Higher"
                },
                {
                    product: "OpenWaterSwimming",
                    name: "Aspire Women's Open Water Swimming Wetsuit",
                    price: 249.95,
                    flexibility: 4, buoyancy: 3.5,
                    speed: 3.5, thermal: 4,
                    describe: "Great for beginners to test out open water",
                    image_url: "https://eu.sumarpo.com/cdn/shop/files/16_1abfe1ae-10ab-4ea1-9e66-1ba736dcbe7a_720x.jpg?v=1761197677",
                    product_url: "https://eu.sumarpo.com/products/aspire-womens-open-water-swimming-wetsuit",
                    ProductOptions: "Lower"
                },
                {
                    product: "OpenWaterSwimming",
                    name: "Nova Women's Eco Sleeveless Open Water Swimming Wetsuit",
                    price: 299.95,
                    flexibility: 5, buoyancy: 3.5,
                    speed: 3.5, thermal: 3,
                    describe: "For more comfortable swims in the summer",
                    image_url: "https://eu.sumarpo.com/cdn/shop/files/26_cb84097a-0e88-4944-a8bc-5e660c84b70b_1800x1800.jpg?v=1766125870",
                    product_url: "https://eu.sumarpo.com/products/womens-nova-sleeveless-eco-open-water-swimming-wetsuit-presale",
                    ProductOptions: "Higher"
                },
                {
                    product: "OpenWaterSwimming",
                    name: "N-Joy Women's Eco Open Water Swimming Wetsuit",
                    price: 254.95,
                    flexibility: 4, buoyancy: 3.5,
                    speed: 4, thermal: 4,
                    describe: "Easily fit every body type",
                    image_url: "https://eu.sumarpo.com/cdn/shop/files/5-14-10364089_1280x1800_f106b00c-db78-4cb5-a74a-51c4698b70a7_1800x1800.jpg?v=1779343755",
                    product_url: "https://eu.sumarpo.com/products/womens-n-joy-eco-open-water-swimming-wetsuit",
                    ProductOptions: "Lower"
                }
            ]
        }]
